import { mdiHeart, mdiHeartOutline } from "@mdi/js";
import niceDate from "@/lib/nice-date";
import getAnyDescription from "@/lib/get-any-description";
import { getShortTitle, getTitle } from "@/lib/get-short-title";
import ColorsMixin from "@/mixins/ColorsMixin.vue";
import EventPicture from "@/components/EventPicture/EventPicture.vue";
import moment from "moment";
import findMomentsForEventId from "@/lib/find-moments-for-event-id";
import "./Card.sass";
import {appendCurrentParamsToURL} from "@/helpers/commonHelper";

export default {
  name: "eo-card",
  components: { EventPicture },
  mixins: [ColorsMixin],
  props: {
    event: {
      type: Object,
      required: true
    },
    events: {
      type: Array
    },
    cols: {
      type: Number,
      required: true
    },
    settings: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    apiKey: String,
    showNotepad: Boolean
  },
  data: () => ({
    isMouseOver: false,
    // icons
    mdiHeart: mdiHeart,
    mdiHeartOutline: mdiHeartOutline,
    showCopyrightInList: true
  }),
  computed: {
    title() {
      return getTitle(this.event);
    },
    shortTitle() {
      return getShortTitle(this.event);
    },
    momentCancelled() {
      if (this.event?.moment && this.event?.moment?.cancelled)
        return this.event.moment.cancelled;
      if (this.event?.cancelled) return this.event.cancelled;
    },
    description() {
      return getAnyDescription(this.event);
    },
    location() {
      if (this.event && this.settings) {
        if (this.event?.location?.length && this.event?.location?.[0]?.title) {
          let locationTitle = this.event?.location?.[0]?.title;
          if (this.event?.location?.[0]?.address) {
            let hasCity = false;
            if (
              this.settings.displayLocationCity &&
              this.event?.location?.[0]?.address?.city
            ) {
              locationTitle += ", " + this.event?.location?.[0]?.address?.city;
              hasCity = true;
            }
            if (
              this.settings.displayLocationDistrict &&
              this.event?.location?.[0]?.address?.district
            ) {
              locationTitle +=
                (hasCity ? "-" : "") +
                this.event?.location?.[0]?.address?.district;
            }
            if (
              this.settings.displayLocationCountry &&
              this.event?.location?.[0]?.address?.country
            ) {
              locationTitle +=
                ", " + this.event?.location?.[0]?.address?.country;
            }
          }
          return locationTitle;
        }
        if (this.event.location_text) return this.event.location_text;
      }
      return "";
    },
    niceDate() {
      if (this.event && this.event.moment && this.event.moment.from) {
        return niceDate(this.event.moment.from, this.$i18n.locale);
      }
      return "";
    },
    niceTime() {
      if (this.event && this.event.moment && this.event.moment.from) {
        return niceDate(this.event.moment.from, this.$i18n.locale, true);
      }
      return "";
    },
    href() {
      if (this.$store.state.targetUri) {
        // replace place holder strings with meaningful stuff
        let uri = this.$store.state.targetUri.replace(
          /xxxSLUGxxx/,
          this.event.url_slug
        );

        if (this.event.moment) {
          uri = uri.replace(/xxxMOMENTxxx/, this.event.moment._id);
        } else {
          uri = uri.replace(/(\/)?xxxMOMENTxxx/, "");
        }

        return appendCurrentParamsToURL(uri);
      }
      return "";
    },
    isFavorite() {
      const id =
        this.event._id + (this.event.moment ? ":" + this.event.moment._id : "");

      return (
        this.$store.state.favorites &&
        this.$store.state.favorites.indexOf(id) > -1
      );
    },
    isRolloverMapLocationId() {
      return (
        this.$store.state.rolloverMapLocationId &&
        this.event?.location?.[0] &&
        this.$store.state.rolloverMapLocationId ===
          this.event?.location?.[0]?._id?.toString()
      );
    }
  },
  methods: {
    heartClicked() {
      const id =
        this.event._id + (this.event.moment ? ":" + this.event.moment._id : "");
      if (this.isFavorite) {
        this.$store.commit("removeFavorite", id);
      } else {
        this.$store.commit("addFavorite", id);
      }
    },
    onMouseEnter() {
      this.isMouseOver = true;

      // mark store marker that we have entered a card with location id
      if (
        this.event &&
        this.event?.location?.[0] &&
        this?.event?.location?.[0]?._id
      ) {
        this.$store.commit(
          "rolloverCardLocationId",
          this.event?.location?.[0]?._id
        );
      }
    },

    async showMoreEventsButton() {
      const today = moment();
      const moments = await findMomentsForEventId(
        this.$store.state.apiUrl,
        this.$store.state.apiKey,
        this.event._id
      );
      const futureDates = moments.filter(date => {
        return moment(date.from).isSameOrAfter(today);
      });
      return futureDates.length > 1;
    },
    onMouseLeave() {
      this.isMouseOver = false;
      // clear store marker
      this.$store.commit("rolloverCardLocationId", undefined);
    }
  }
};
